import React from "react";
import "./form-builder.form-empty.sass";
const FormBuilderFormEmpty = () => {
  return /* @__PURE__ */ React.createElement("div", { className: "form-builder-form-empty" }, /* @__PURE__ */ React.createElement("span", { className: "form-builder-form-empty__title" }, "Blank Form"), /* @__PURE__ */ React.createElement("span", { className: "form-builder-form-empty__caption" }, "Add at least 1 field to the form to get started."));
};
FormBuilderFormEmpty.displayName = "FormBuilderFormEmpty";
export default React.memo(FormBuilderFormEmpty);
